import React from 'react';
import { Button, Form, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import ReactTable from 'Common/ReactTableWrapper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { ManageTruckRouteScheduleListEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

const ManageTruckRouteScheduleList = props => {
  const {
    columns,
    clearFilters,
    showDeleteConfirm,
    selectedRouteSchedule,
    handleDeleteDialog,
    setReactTableWrapperInstance,
    routeScheduleData,
    truckRouteScheduleDataLoading,
  } = props;
  const deleteQuestion = `Are you sure you would like to permanently delete route schedule # ${selectedRouteSchedule &&
    selectedRouteSchedule[ManageTruckRouteScheduleListEnum.Description]}?`;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column floated={'right'} textAlign={'right'}>
            <Button
              content="Clear Filters"
              onClick={e => clearFilters()}
              type={'button'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <ReactTable
            defaultPageSize={20}
            showPageSizeOptions={true}
            minRows={0}
            data={routeScheduleData}
            noDatatext={'No rows found'}
            resizable={false}
            className="-striped -highlight grid--fixed-row-height"
            defaultFilterMethod={caseInsensitiveFilter}
            columns={columns}
            menu={false}
            loading={truckRouteScheduleDataLoading}
            saveState={{
              tableName: TableNamesEnum.MANAGE_TRUCK_ROUTE_SCHEDULE_TABLE,
            }}
            onRef={setReactTableWrapperInstance}
          />
        </Grid.Row>
      </Grid>
      <YesNoDialog
        showDialog={showDeleteConfirm}
        title="Delete Route Schedule"
        question={deleteQuestion}
        yesCallback={() => {
          handleDeleteDialog(true);
        }}
        noCallback={() => {
          handleDeleteDialog(false);
        }}
      />
    </Form>
  );
};
ManageTruckRouteScheduleList.propTypes = {
  columns: PropTypes.array,
  clearFilters: PropTypes.func,
  showDeleteConfirm: PropTypes.bool,
  selectedRouteSchedule: PropTypes.object,
  handleDeleteDialog: PropTypes.func,
  setReactTableWrapperInstance: PropTypes.func,
  routeScheduleData: PropTypes.array,
  truckRouteScheduleDataLoading: PropTypes.bool,
};

ManageTruckRouteScheduleList.defaultProps = {
  columns: [],
  clearFilters: () => {},
  showDeleteConfirm: false,
  selectedRouteSchedule: null,
  handleDeleteDialog: () => {},
  setReactTableWrapperInstance: () => {},
  routeScheduleData: [],
  truckRouteScheduleDataLoading: false,
};

export default ManageTruckRouteScheduleList;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/managetruckrouteschedulelist/ManageTruckRouteScheduleList.js